"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPictureInPictureFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M4 5h14v3h2V5a2 2 0 00-2-2H4a2 2 0 00-2 2v11a2 2 0 002 2h4v-2H4V5z' }),
    react_1.default.createElement("path", { d: 'M10 12a2 2 0 012-2h8a2 2 0 012 2v7a2 2 0 01-2 2h-8a2 2 0 01-2-2v-7z' }))); };
exports.default = SvgPictureInPictureFilled;
//# sourceMappingURL=PictureInPictureFilled.js.map